/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Camera_Attach_OpenInputs */

const vi_camera_attach_open = /** @type {(inputs: Camera_Attach_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gắn camera có sẵn`)
};

/**

* @param {Camera_Attach_OpenInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const camera_attach_open = /** @type {((inputs?: Camera_Attach_OpenInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Camera_Attach_OpenInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_camera_attach_open(inputs)
});